module.exports = __webpack_public_path__ + "assets/e5bbef1127a6743db5d1ec390ceaf055.jpg";